<template>
  <v-card title="Teams">
    <v-card-text>
      <v-data-table-server
        v-model="yearTeams.selected"
        v-model:page="pagination.skip"
        :headers="yearTeams.headers"
        :items="yearTeams.data"
        :items-per-page="pagination.limit"
        item-key="id"
        :loading="yearTeams.loading"
        :items-length="yearTeams.count"
        :search="pagination.q"
        @update:options="handleBranchYearTeamChange">
        <template v-slot:[`item.action`]="{ item }">
          <v-row justify="end">
            <v-col cols="auto">
              <router-link
                :to="{
                  name: 'AdminYearTeamDetailView',
                  params: { yearId: yearId, teamId: item.id },
                }">
                <v-icon icon="mdi-pencil">
                  <v-tooltip activator="parent" location="end">Edit Team</v-tooltip>
                </v-icon></router-link
              >
            </v-col>
          </v-row>
        </template>
        <template v-slot:top>
          <v-text-field
            v-model="pagination.q"
            class="ma-2"
            density="compact"
            placeholder="Search branch year..."
            hide-details></v-text-field>
          <v-btn color="primary" @click="exportToCSV(yearTeams.headers, yearTeams.data)"
            >Export to CSV</v-btn
          >
        </template>
      </v-data-table-server>
    </v-card-text>
  </v-card>
</template>
<script setup lang="ts">
import { IHeaderDTO, IPaginationDTO, PaginationDTO } from '@/dtos';
import { computed, ref } from 'vue';
import type { VDataTableServer } from 'vuetify/components';
import { exportToCSV } from '@/helpers';
import { useTeamStore } from '@/stores';

interface Props {
  yearId: string;
}
const props = defineProps<Props>();
const teamStore = useTeamStore();
const yearId = computed(() => props.yearId);
const pagination = ref<IPaginationDTO>(new PaginationDTO());
const query = teamStore.getTeamsForYearQuery(yearId, pagination);
const loading = computed(() => query.isLoading.value);
const data = computed(() => query.data.value?.data ?? []);
const count = computed(() => query.data.value?.count ?? 0);
const yearTeams = ref({
  count: count,
  data: data,
  loading: loading,
  selected: [] as string[],
  headers: [
    { title: 'Team', key: 'name', align: 'start', sortable: true },
    {
      title: 'Branch',
      key: 'teamCriteria[0].branchYear.branch.name',
      align: 'start',
      sortable: true,
    },
    {
      title: 'Level',
      key: 'teamCriteria[0].teamLevel.team_level',
      align: 'start',
      sortable: true,
    },
    {
      title: 'Team Leader First Name',
      key: 'teamLeader.first_name',
      align: 'start',
      sortable: true,
    },
    { title: 'Team Leader Last Name', key: 'teamLeader.last_name', align: 'start', sortable: true },
    {
      title: 'Team Leader Email Address',
      key: 'teamLeader.email_address',
      align: 'start',
      sortable: true,
    },
    { title: '', key: 'action', align: 'end', sortable: false },
  ] as IHeaderDTO[],
});

const handleBranchYearTeamChange = (value: VDataTableServer) => {
  pagination.value.buildPagination(value);
};
</script>
